export const BFile_filters = (set, get) => ({
    fSfilters: {
        searchText: "",
        selectedAgency: "",
        page: 1,
        selectedRole: "",
        datemodified: {
            start_date: "2010-01-01",
            end_date: "2050-01-01"
        },
        direction: "",
        field: "",
        filter_by_column_name:{},
        gridSelectedCarriers: [],
        gridSelectedAgencyState: [],
        gridSelectedAgencies: [],
        gridFilteredAgencyIds: [],
    },
    setFsFilters: (newFilter) =>
        set((state) => ({
            fSfilters: {
                ...state.fSfilters,
                ...newFilter,
                datemodified: {
                    ...state.fSfilters.datemodified,
                    ...newFilter.datemodified,
                }
            },
        })),
    resetFsFilters: () =>
        set(() => ({
            fSfilters: {
                searchText: "",
                selectedAgency: "",
                page: 1,
                selectedRole: "",
                datemodified: {
                    start_date: "2010-01-01",
                    end_date: "2050-01-01"
                },
                direction: "",
                field: "",
                filter_by_column_name:{},
                gridSelectedCarriers: [],
                gridSelectedAgencyState: [],
                gridSelectedAgencies: [],
                gridFilteredAgencyIds: [],
            }
        })),

});



// WEBPACK FOOTER //
// ./src/store/slices/FS/BFile_Filters.js